import * as types from 'constants/actionTypes'
import unset from 'lodash/unset'

const initialState = {
  initializing: true
}

export default function (state = initialState, action) {
  switch (action.type) {

    case types.AUTH_DATA:
      return action.authData

    case types.LOGOUT:
      return {}

    case types.AUTH_INITIALIZED:
      const newState = {...state}
      unset(newState, 'initializing')
      return newState

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authData.js